import "./plantCBConsumption.css";
import { useState, useEffect } from "react";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import Moment from 'moment';
import * as React from 'react';
import { authKey, PLANT_ACTUAL_PLANT_CONSUMPTION, GET_PLANT_INVENTORIES, UPDATE_PLANT_INVENTORIES, } from "../../../common/URLs";
import { loaderService } from "../../../common/custom-loader/loader-service";

import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import { ErrorPopover } from "../../../common/ErrorPopover/errorPopover";
import { confirmAlert } from "react-confirm-alert";
import { Container, DialogContent, Dialog, DialogActions, Button, Typography, Card, CardContent, Grid, FormControl, TextField, Box, FormHelperText } from '@mui/material';
import { CommonInnerSidebar } from '../../../common/common-inner-sidebar/commonInnerSidebar';
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { PROD } from "../../../common/constants";
import HeapPopOver from "../chipping/heapPopover";
import { toast } from "react-toastify";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DataGrid } from "@mui/x-data-grid";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import { SubmitIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function PlantCBConsumption() {

  const navigate = useNavigate();

  const [plantconsumptiondate, setPlantconsumptiondate] = useState(null);

  const [plantConsumptionResponse, setPlantConsumptionResponse] = React.useState();

  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);

  const [logModalOpen1, setLogModalOpen1] = useState(false);
  const handleLogModalOpen1 = () => setLogModalOpen1(true);
  const handleLogModalClose1 = () => setLogModalOpen1(false);
  const [logModalOpen2, setLogModalOpen2] = useState(false);
  const [selectedHeap, setSelectedHeap] = useState([]);
  const [newArrayList, setNewArrayList] = useState([]);
  const [getPlantInventories, setPlantInventoriesDetails] = useState();
  const [getUpdatePlantInventories, setUpdatePlantInventories] = useState();

  const [logModalOpen4, setLogModalOpen4] = useState(false);
  const handleLogModalOpen4 = () => setLogModalOpen4(true);
  const handleLogModalClose4 = () => setLogModalOpen4(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const handleConfirmOpen = () => setConfirmOpen(true);
  const handleConfirmClose = () => setConfirmOpen(false);

  const [heapList, setHeapList] = useState();
  const [consumptionQuantity, setConsumptionQuantity] = useState('');
  const [consumptionDetails, setConsumptionDetails] = React.useState({
    "consumptionQuantity": '',
    // "totalCbQuantityDelivered": "",
    // // "eodInventory": "",
    // "unrestrictedQuantity": "",
    // "restrictedQuantity": "",
    // "scrapQuantity": ""
  });
  const [errorMessage, setErrorMessage] = React.useState({
    "dateError": "",
    "consumptionQuantityError": "",
    // "totalCbQuantityDeliveredError": "",
    // // "eodInventoryError": "",
    // "unrestrictedQuantityError": "",
    // "restrictedQuantityError": "",
    // "scrapQuantityError": ""
  });

  const handleDateChange = (e) => {
    if (e.format("YYYY-MM-DD")) {
      setErrorMessage({ ...errorMessage, dateError: "" });
    }
    setPlantconsumptiondate(e.format("YYYY-MM-DD"));
  }

  const addActualPlantConsumption = (e) => {
    loaderService.showLoader();
    let heapIds = selectedHeap.map(heap => heap.id);
    apiClient
      .post(
        PLANT_ACTUAL_PLANT_CONSUMPTION,
        {
          "date": plantconsumptiondate,
          "consumptionQuantity": consumptionQuantity,
          "inventoryIds": [
            ...heapIds
          ]
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        }
      )
      .then((response) => {
        setPlantConsumptionResponse(response.data);
        setPlantconsumptiondate(null);
        setConsumptionQuantity('');
        setSelectedHeap([]);
        getPlantInventories1();
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  };

  // const updateInventories = (e) => {
  //   loaderService.showLoader()
  //   let heapIds = selectedHeap.map(heap => heap.id);
  //   apiClient
  //     .post(
  //       UPDATE_PLANT_INVENTORIES,
  //       {
  //         "inventoryIds": [
  //           ...heapIds
  //         ]
  //       },
  //       {
  //         headers: {
  //           Authorization: "Bearer " + getLocalStorageItem('id_token'),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setLogModalOpen2(true);
  //       loaderService.hideLoader()
  //     })
  //     .catch(function (error) {
  //       console.log(error);
  //       setLogModalOpen1(true);
  //       loaderService.hideLoader();

  //     });
  // }

  const onConfirmApprove = (e) => {
    handleConfirmClose();
    onSubmit(e);
  }

  const onSubmitButtonClick = (e) => {
    handleConfirmOpen();
  }

  const onSubmit = (e) => {
    if (!plantconsumptiondate) {
      setErrorMessage({ ...errorMessage, dateError: "Please select date" });
    }
    else if (!consumptionQuantity) {
      setErrorMessage({ ...errorMessage, consumptionQuantityError: "Please enter consumption quantity" });
    }
    // else if (!consumptionDetails?.totalCbQuantityDelivered) {
    //   setErrorMessage({ ...errorMessage, totalCbQuantityDeliveredError: "Please enter total chipped bamboo delivered" });
    // }
    // else if (!consumptionDetails?.eodInventory) {
    //   setErrorMessage({ ...errorMessage, eodInventoryError: "Please enter plant inventory at the end of the day" });
    // }
    // else if (!consumptionDetails?.unrestrictedQuantity) {
    //   setErrorMessage({ ...errorMessage, unrestrictedQuantityError: "Please enter unrestricted quantity" });
    // }
    //   else if (!consumptionDetails?.unrestrictedQuantity && !consumptionDetails?.restrictedQuantity && !consumptionDetails?.scrapQuantity) {
    //     setErrorMessage({ ...errorMessage, unrestrictedQuantityError: "Please enter total chipped bamboo delivered" });
    //   }
    else {
      addActualPlantConsumption();
    }

  }

  const handleChange = (e) => {
    const limit = 6;
    setConsumptionQuantity(e.target.value.slice(0, limit))

    setConsumptionDetails({ ...consumptionDetails, [e.target.name]: e.target.value });
    // if (e.target.value.length > e.target.maxLength)
    //   e.target.value = e.target.value.slice(0, e.target.maxLength);

    if (consumptionQuantity) {
      setErrorMessage({ ...errorMessage, consumptionQuantityError: "" });
    }
    if (e.target.name === "totalCbQuantityDelivered") {
      setErrorMessage({ ...errorMessage, totalCbQuantityDeliveredError: "" });
    }
    // if (e.target.name === "eodInventory") 
    // {
    //   setErrorMessage({ ...errorMessage, eodInventoryError: "" });
    // }
    if (e.target.name === "unrestrictedQuantity") {
      setErrorMessage({ ...errorMessage, unrestrictedQuantityError: "" });
    }
    if (e.target.name === "restrictedQuantity") {
      setErrorMessage({ ...errorMessage, restrictedQuantityError: "" });
    }
    if (e.target.name === "scrapQuantity") {
      setErrorMessage({ ...errorMessage, scrapQuantityError: "" });
    }
  }
  useEffect(() => {
    if (plantConsumptionResponse) {
      if (plantConsumptionResponse.isSuccess === true) {
        toast.success(plantConsumptionResponse?.message)
        // handleLogModalOpen1();
      }
      else {
        toast.error(plantConsumptionResponse?.message ? plantConsumptionResponse?.message : "Error")
        // handleLogModalOpen();
      }
    }
  }, [plantConsumptionResponse]);

  const getselectedHeapDetails = (heapList) => {
    // console.log(heapList);
    let heapsFinal = heapList.filter(heap => heap.isSelected ? true : false);
    setSelectedHeap(heapsFinal);
  }

  const onClickBundle = (onClose) => {
    // props.selectedHeap();
    // confirmAlert({
    //   customUI: ({ onClose }) => {
    //     return (
    //       <HeapPopOver heapsList={heapList} selectedHeap={selectedHeap} newArrayList={newArrayList} onClose={onClose} heapSubmitCallbackFunction={getselectedHeapDetails} />
    //     );
    //   }
    // });
    handleLogModalOpen4(onClose);
  }
  useEffect(() => {
    getPlantInventories1();
  }, []);
  const getPlantInventories1 = () => {
    loaderService.showLoader();
    apiClient
      .post(
        GET_PLANT_INVENTORIES,
        {},
        {
          headers: {
            Authorization: " Bearer " + getLocalStorageItem('id_token'),
          },
        }
      ).then(response => {
        setHeapList(response.data.inventories);
        loaderService.hideLoader();
      })


  }

  const columns = [
    {
      field: 'heapNumber', headerName: 'Heap No.', width: 230,
      valueGetter: (params) => {
        return params.row.heapNumber ? params.row.heapNumber : params.row.bundleId
      }
    },
    {
      field: 'pickupWeight', headerName: 'GRN Weight', width: 150,
    },
    {
      field: 'pickupMoisture', headerName: 'Moisture', width: 150,
    },
  ];




  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT31</p>}
        <Typography variant="h5" gutterBottom>
          Plant CB Consumption
        </Typography>
        <Card>
          <CardContent>
            <Grid container spacing={2} direction="row" mt={1}>
              <Grid item xs={12} lg={4}>
                <FormControl fullWidth required error={errorMessage.dateError}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Start Date"
                      inputFormat="DD/MM/YYYY"
                      value={plantconsumptiondate}
                      maxDate={Moment().toDate()}
                      onChange={(e) => { handleDateChange(e) }}
                      renderInput={(params) => <TextField size="small" {...params} />}
                    />
                  </LocalizationProvider>
                  <FormHelperText sx={{ color: 'red' }}>{errorMessage.dateError}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField fullWidth size='small'
                  required
                  error={errorMessage.consumptionQuantityError}
                  helperText={errorMessage.consumptionQuantityError}
                  label='Plant Consumption Quantity'
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  value={consumptionQuantity}
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-') && evt.preventDefault()}
                  maxLength={6}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <Button onClick={onClickBundle}>Select Heap</Button>
              </Grid>
            </Grid>
            {selectedHeap.length > 0 &&
              <Box style={{ height: 300, width: '100%', marginTop: '2vh' }}>
                {
                  selectedHeap &&
                  <DataGrid rows={selectedHeap}
                    columns={columns}
                    pageSize={5}
                    getRowId={(row) => row?.id}
                  />
                }
              </Box>
            }


          </CardContent>
        </Card>
        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
          {selectedHeap.length > 0 &&
            <Button endIcon={<SubmitIcon />} sx={{ minWidth: 100 }} variant="contained" type='submit' onClick={(e) => onSubmitButtonClick(e)}>Submit</Button>}
        </Box>

      </Container>
      <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmApprove} onClose={handleConfirmClose} action="Submit" />

      <Dialog maxWidth='md' fullWidth open={logModalOpen4}>
        <DialogContent>
          <HeapPopOver heapsList={heapList} selectedHeap={selectedHeap} newArrayList={newArrayList} handleLogModalClose={handleLogModalClose4} heapSubmitCallbackFunction={getselectedHeapDetails} />
        </DialogContent>
      </Dialog>

      <Dialog maxWidth='xs' fullWidth open={logModalOpen2}>
        <DialogContent>
          <ConfirmPopover title={"Inventories Updated Successfully"} hideLink={true} />    </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogModalOpen2(false)}>OK</Button>
        </DialogActions>
      </Dialog>

      {/* <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
        <DialogContent>
          <ConfirmPopover title={plantConsumptionResponse?.message} hideLink={true} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose}>OK</Button>
        </DialogActions>
      </Dialog>

      <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
        <DialogContent>
          <ErrorPopover title={plantConsumptionResponse?.message ? plantConsumptionResponse?.message : "Error"} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLogModalClose1}>OK</Button>
        </DialogActions>
      </Dialog> */}
    </>
  )
}
export default PlantCBConsumption;
